import React, { useEffect, useState } from "react";
import { Modal, notification } from "antd";
import {
    IoMailOutline,
    IoPersonOutline,
    IoLockClosedOutline,
    IoEyeOutline,
    IoEyeOffOutline,
    IoShieldCheckmarkOutline,
    IoCheckmarkOutline,
} from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../utils/config";
import logo from '../../assests/images/weblogo.png';
function SignUp() {
    const [userName, setUserName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [userPassword, setUserPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checkedValue, setCheckedValue] = useState(false);

    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    const user = userData ? JSON.parse(userData) : null;

    useEffect(() => {
        if (token && user) {
            if (user.type === "admin") {
                navigate("/admin");
            } else if (user.type === "user") {
                navigate("/user");
            }
        }
    }, []);

    const handleSubmit = async (e) => {
        e?.preventDefault();

        if (!userName || !userEmail || !userPassword) {
            notification.error({ message: "All fields are required" });
            return;
        }

        if (userPassword.length < 8) {
            notification.error({ message: "Password must be at least 8 characters long" });
            return;
        }

        if (!checkedValue) {
            notification.error({ message: "Please agree to our terms and conditions." });
            return;
        }

        setLoading(true);

        try {
            const registrationData = {
                name: userName,
                email: userEmail,
                password: userPassword,
                type: "user",
            };

            const response = await axios.post(`${BASE_URL}register`, registrationData);

            if (response?.data) {
                setLoading(false);
                const token = response.data.authorisation.token;
                const user = response?.data?.user;

                localStorage.setItem("user", JSON.stringify(user));
                localStorage.setItem("token", token);
                localStorage.setItem("timestamp", Date.now() + 3600 * 1000);
                localStorage.setItem("time", Date.now());

                notification.success({ message: response?.data?.message });

                if (user.type === "admin") {
                    navigate("/admin");
                } else {
                    navigate("/user");
                }
            }
        } catch (error) {
            setLoading(false);

            if (error.response?.data?.errors) {
                const errors = error.response.data.errors;
                if (errors.name) { notification.error({ message: errors.name[0] }); return; }
                if (errors.email) { notification.error({ message: errors.email[0] }); return; }
                if (errors.password) { notification.error({ message: errors.password[0] }); return; }
            } else {
                notification.error({ message: "An error occurred during registration." });
            }
        }
    };

    const features = [
        "Instant crypto & fiat conversions",
        "Bank-grade security & encryption",
        "Real-time portfolio analytics",
    ];

    const checks = [
        "Account details validity",
        "Login source verification",
        "Quick threat scan",
    ];

    if (token && user) return null;

    return (
        <div className="min-h-screen flex bg-[#080810]">

            {/* ── LEFT PANEL ── */}
            <div className="hidden lg:flex w-[46%] min-h-screen relative flex-col p-10 gap-10 overflow-hidden bg-[#0c0b18]">

                {/* Grid bg */}
                <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                        backgroundImage:
                            "linear-gradient(rgba(109,40,217,0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(109,40,217,0.07) 1px, transparent 1px)",
                        backgroundSize: "44px 44px",
                    }}
                />
                {/* Radial glow */}
                <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                        background:
                            "radial-gradient(ellipse 90% 55% at 50% -5%, rgba(109,40,217,0.38) 0%, transparent 70%), radial-gradient(ellipse 60% 70% at 90% 90%, rgba(192,38,211,0.18) 0%, transparent 60%)",
                    }}
                />

                {/* Logo */}
                <div className="relative z-10 flex items-center gap-2.5">
                    <Link to="/">
                        <img src={logo} alt="elementuslabs Logo" className="h-11 w-auto object-contain" />
                    </Link>
                </div>

                {/* Body */}
                <div className="relative z-10 flex flex-col gap-8 flex-1 justify-center">

                    <div className="flex flex-col gap-3">
                        <h1 className="text-4xl xl:text-5xl font-extrabold text-white leading-[1.08] tracking-tight">
                            Your gateway to{" "}
                            <span className="bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text text-transparent">
                                digital wealth.
                            </span>
                        </h1>
                        <p className="text-sm text-white/80 leading-relaxed max-w-sm">
                            Manage crypto, track balances, and move money globally — all from one beautifully crafted dashboard.
                        </p>
                    </div>

                    {/* Features */}
                    <div className="flex flex-col gap-3">
                        {features.map((f) => (
                            <div key={f} className="flex items-center gap-3 text-white/50 text-sm">
                                <div className="w-1.5 h-1.5 rounded-full bg-gradient-to-br from-violet-500 to-fuchsia-500 flex-shrink-0" />
                                {f}
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            {/* ── RIGHT PANEL ── */}
            <div className="flex-1 flex items-center justify-center px-6 py-12 lg:border-l lg:border-white/5">
                <div className="w-full max-w-md">

                    {/* Mobile logo */}
                    <div className="flex lg:hidden items-center gap-2.5 mb-8">
<Link to="/">
            <img src={logo} alt="elementuslabs Logo" className="h-11 w-auto object-contain" />
          </Link>
                    </div>

                    {/* Header */}
                    <div className="mb-8">
                        <div className="inline-flex items-center gap-1.5 bg-violet-500/10 border border-violet-500/25 text-violet-400 text-[11px] font-medium tracking-wider px-3 py-1 rounded-full mb-4">
                            <IoShieldCheckmarkOutline />
                            Free to join
                        </div>
                        <h2 className="text-[2rem] font-extrabold text-white tracking-tight leading-tight mb-1">
                            Create account
                        </h2>
                        <p className="text-sm text-white/80">Get started in under two minutes.</p>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4" autoComplete="off">

                        {/* Email */}
                        <div className="flex flex-col gap-1.5">
                            <label className="text-[12px] font-medium text-white tracking-wide">
                                Email address
                            </label>
                            <div className="relative">
                                <IoMailOutline className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/25 text-[15px] pointer-events-none" />
                                <input
                                    type="email"
                                    placeholder="you@example.com"
                                    value={userEmail}
                                    onChange={(e) => setUserEmail(e.target.value)}
                                    onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                                    className="w-full h-11 bg-white/[0.04] border border-white/[0.08] rounded-xl text-white text-sm pl-10 pr-4 outline-none placeholder:text-white/20 focus:border-violet-500/60 focus:bg-violet-500/[0.06] transition-all duration-200"
                                />
                            </div>
                        </div>

                        {/* Full Name */}
                        <div className="flex flex-col gap-1.5">
                            <label className="text-[12px] font-medium text-white tracking-wide">
                                Full name
                            </label>
                            <div className="relative">
                                <IoPersonOutline className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/25 text-[15px] pointer-events-none" />
                                <input
                                    type="text"
                                    placeholder="Jane Eyre"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                    onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                                    className="w-full h-11 bg-white/[0.04] border border-white/[0.08] rounded-xl text-white text-sm pl-10 pr-4 outline-none placeholder:text-white/20 focus:border-violet-500/60 focus:bg-violet-500/[0.06] transition-all duration-200"
                                />
                            </div>
                        </div>

                        {/* Password */}
                        <div className="flex flex-col gap-1.5">
                            <label className="text-[12px] font-medium text-white tracking-wide">
                                Password
                            </label>
                            <div className="relative">
                                <IoLockClosedOutline className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/25 text-[15px] pointer-events-none" />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Min. 8 characters"
                                    value={userPassword}
                                    onChange={(e) => setUserPassword(e.target.value)}
                                    onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                                    className="w-full h-11 bg-white/[0.04] border border-white/[0.08] rounded-xl text-white text-sm pl-10 pr-11 outline-none placeholder:text-white/20 focus:border-violet-500/60 focus:bg-violet-500/[0.06] transition-all duration-200"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword((p) => !p)}
                                    className="absolute right-3.5 top-1/2 -translate-y-1/2 text-white/25 hover:text-white/60 transition-colors cursor-pointer"
                                    tabIndex={-1}
                                >
                                    {showPassword
                                        ? <IoEyeOffOutline className="text-[15px]" />
                                        : <IoEyeOutline className="text-[15px]" />
                                    }
                                </button>
                            </div>
                        </div>

                        {/* Terms checkbox */}
                        <div className="flex items-start gap-2.5 mt-1">
                            <div
                                onClick={() => setCheckedValue((v) => !v)}
                                className={`w-[18px] h-[18px] rounded-[5px] border flex-shrink-0 mt-0.5 flex items-center justify-center cursor-pointer transition-all duration-150 ${checkedValue
                                    ? "bg-gradient-to-br from-violet-600 to-fuchsia-600 border-transparent"
                                    : "bg-white/[0.04] border-white/15"
                                    }`}
                            >
                                {checkedValue && (
                                    <IoCheckmarkOutline className="text-white" style={{ fontSize: 11 }} />
                                )}
                            </div>
                            <p className="text-[12px] text-white leading-relaxed select-none cursor-pointer" onClick={() => setCheckedValue((v) => !v)}>
                                I agree to the{" "}
                                <a href="#" className="text-violet-400 hover:text-violet-300 transition-colors">
                                    Terms of Service
                                </a>{" "}
                                and{" "}
                                <a href="#" className="text-violet-400 hover:text-violet-300 transition-colors">
                                    Privacy Policy
                                </a>
                            </p>
                        </div>

                        {/* Submit */}
                        <button
                            type="submit"
                            disabled={loading || !checkedValue}
                            className="w-full h-12 rounded-xl bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold text-sm tracking-wide flex items-center justify-center gap-2.5 mt-1 hover:opacity-90 active:scale-[0.985] transition-all duration-150 disabled:opacity-40 disabled:cursor-not-allowed"
                        >
                            {loading && (
                                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            )}
                            {loading ? "Creating account…" : "Create account"}
                        </button>

                    </form>

                    {/* Footer */}
                    <p className="text-center text-sm text-white/80 mt-6">
                        Already have an account?{" "}
                        <Link
                            to="/login"
                            className="text-violet-400 font-semibold hover:text-violet-300 transition-colors"
                        >
                            Sign in
                        </Link>
                    </p>

                </div>
            </div>

            {/* ── Verification Modal ── */}
            <Modal
                open={loading}
                footer={null}
                closable={false}
                width={440}
                centered
                styles={{
                    content: {
                        background: "#0f0e1c",
                        borderRadius: 16,
                        padding: 0,
                        border: "1px solid rgba(255,255,255,0.07)",
                    },
                    mask: {
                        backdropFilter: "blur(6px)",
                        background: "rgba(0,0,0,0.7)",
                    },
                }}
            >
                <div className="p-8 text-center">

                    {/* Spinner */}
                    <div className="w-14 h-14 rounded-full border-[3px] border-violet-500/15 border-t-violet-500 animate-spin mx-auto mb-6" />

                    <h3 className="text-lg font-bold text-white mb-1 tracking-tight">
                        Verifying your details
                    </h3>
                    <p className="text-sm text-white/35 mb-7">
                        Running security checks — just a moment.
                    </p>

                    <div className="flex flex-col gap-2.5">
                        {checks.map((label, i) => (
                            <div
                                key={i}
                                className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white/[0.03] border border-white/[0.06]"
                            >
                                <div className="w-7 h-7 rounded-full bg-violet-500/15 border border-violet-500/25 flex items-center justify-center flex-shrink-0">
                                    <span className="text-[11px] font-bold text-violet-400">{i + 1}</span>
                                </div>
                                <span className="text-[13px] text-white/50 flex-1 text-left">{label}</span>
                                <span className="text-[11px] text-white/20 uppercase tracking-wider">Pending</span>
                            </div>
                        ))}
                    </div>

                </div>
            </Modal>

        </div>
    );
}

export default SignUp;